module.exports = __webpack_public_path__ + "static/img/model-bg22.ec22cf5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg22.jpg
// module id = CPAR
// module chunks = 0